import ApiRequestor from "../../api_access/ApiRequestor";
import {Dispatch} from "redux"
import { GetABMMENUDispatchTypes, GET_ABMMENU_LOADING, GET_ABMMENU_SUCCESS, GET_ABMMENU_FAIL} from './ABMMenuActionTypes';


export const GetABMMenu = () => async (dispatch: Dispatch<GetABMMENUDispatchTypes>) => {
    try {
        dispatch({
            type: GET_ABMMENU_LOADING
        })
        const response : any = await ApiRequestor.requestToApi("/swt-admin/menu-info", "GET");
        dispatch({
            type: GET_ABMMENU_SUCCESS,
            payload: response.data
        })
    } catch(error) {
        console.log(error);
        dispatch({
            type: GET_ABMMENU_FAIL
        })
    }
   
}

